import { toast } from "react-toastify";
import React, { useEffect, useState, useRef } from "react";
import Modal from "@/app/core/layouts/main/components/Modal";
import { Dropdown, Tab, Tabs } from "react-bootstrap";
import { AccountController } from "@/app/core/base/controllers/AccountController";
import { Message } from "@/app/core/util/messages/GeralMessages";
import { ComplainController } from "@/app/core/base/controllers/ComplainController";
import { CompanyController } from "@/app/core/base/controllers/CompanyController";
import { CnpjMask, OnDataChange } from "@/app/core/util/helpers/FieldHelper";
import { DateTranslate } from "@/app/core/util/DateTranslater";
import { ComplainHelper } from "@/app/core/util/helpers/ComplainHelper";
import { TimelineController } from "@/app/core/base/controllers/TimelineController";
import Storage from "@/app/core/util/Storage";
import { EmailController } from "@/app/core/base/controllers/EmailController";
import { CompanyHelper } from "@/app/core/util/helpers/CompanyHelper";
import { ResponseController } from "@/app/core/base/controllers/ResponseController";
import { ServicesController } from "@/app/core/base/controllers/ServicesController";

export default function ComplainResponseModal({ show, onHide, infos }) {
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState({});
    const [response, setResponse] = useState({});
    const [timeline, setTimeline] = useState([]);
    const [responses, setResponses] = useState([]);
    const [selectedServices, setSelectedServices] = useState([]);
    const userData = Storage.getUserData();

    const date = new Date();
    const [change, setChange] = useState(date.getTime());

    function notifyChange() {
        setChange(date.getTime());
    }

    useEffect(() => {
        if (show && infos && infos.id) {
            setData(infos);
            console.log("My Complaim", infos)
            loadTimeline()
            loadResponses()
            if (infos && infos.selectedServices) {
                loadSelectedServices(infos.selectedServices);
            }
        } else {
            setData({});
        }
    }, [show]);

    async function loadResponses() {
        let list = await ResponseController.List(infos.id);
        for(let s of list){
            s.user = await AccountController.GetUser(s.userId);
        }
        list.sort(function (a, b) {
            return b.createdDate.seconds - a.createdDate.seconds;
        });

        setResponses(list);
    }

    async function loadTimeline() {
        const res = await TimelineController.List(infos.id);
        res.sort(function (a, b) {
            return b.createdDate.seconds - a.createdDate.seconds;
        });
        console.log("Dados", res);
        setTimeline(res);
    }

    async function loadSelectedServices(serviceIds) {
        const services = await ServicesController.ListSelectedServices(serviceIds);
        setSelectedServices(services);
    }

    async function save() {
    }

    function handleChange(evt, type) {
        setResponse(OnDataChange(response, evt, type))
    }

    function processLink(phone) {
        let newPhone = phone.replace("-", "");
        newPhone = newPhone.replace(" ", "");
        newPhone = newPhone.replace("(", "");
        newPhone = newPhone.replace(")", "");

        return `https://api.whatsapp.com/send?phone=55${newPhone}`;
    }

    async function saveResponse(){
        if(!response.description){
            toast.error(Message.PendingData)
        }else{
            await ResponseController.Insert({...response, userId: userData.uid, complainId: data.id});
            await TimelineController.Insert({description: `Registrou a seguinte resposta: ${response.description}`, complainId: data.id});
            loadResponses();
            setResponse({description: ""})
        }
    }

    async function deleteComent(item){
       if(window.confirm(Message.DeleteConfirm)){
            await ResponseController.Delete(item.id);
            toast.success(Message.DeleteSuccess);
            loadResponses();
       }
    }

    return (
        <Modal
            title={`Reclamação - ${data && data.createdDate && data.createdDate.seconds}`}
            show={show}
            onHide={onHide}
            isLoading={loading}
            hideBottom={true}
            onSubmit={() => save()}>

            <Tabs
                defaultActiveKey="resumo"
                id="uncontrolled-tab-example">
                <Tab eventKey="resumo" title="Resumo" className="block-content">
                    <div className="content-heading">
                        Reclamação
                    </div>
                    <div className="block block-bordered block-rounded block-fx-pop border-info block-content">
                        <div class="row">
                            <div class="col-6 pt-2">
                                <p class="h3">Cliente</p>
                                <p>
                                    {data && data.user && data.user.name}<br />
                                    {data && data.user && data.user.email}<br />
                                    <a href={data && data.phone && processLink(data.phone)} target="_blank"><i className="fab fa-whatsapp text-success" /> {data && data.phone && data.phone}</a> <br />
                                    id: {data && data.user && data.user.uid}
                                </p>
                            </div>

                            <div class="col-6 text-right pt-2">
                                <p class="h3">Empresa</p>
                                <p>
                                    {data && data.company && data.company.name}<br />
                                    {data && data.company && data.company.email}<br />
                                    {data && data.company && CnpjMask(data.company.taxId)}<br />
                                    id: {data && data.company && data.company.id}<br />
                                </p>
                            </div>
                        </div>
                        <hr />
                        <div className="content-heading">
                            <h4 className="text-muted">Título: {data && data.title}</h4>
                        </div>
                        <p style={{ whiteSpace: "pre-line" }}>
                            Descrição: {data && data.description}
                        </p>

                        <div className="row">
                            {data && data.images && data.images.length > 0 ? <div className="col-md-12">Imagens</div>:""}
                            {data && data.images && data.images.map((item, index) => (
                                <a class="block block-rounded block-fx-pop col-md-4" href={item.url} target="_blank">
                                    <div class="block-content p-0 overflow-hidden">
                                        <a class="img-link img-fluid-100" >
                                            <img class="img-avatar img-avatar-thumb img-avatar-rounded" src={item.url} />
                                        <span class="font-size-sm text-muted">{item.name}</span>
                                        </a>
                                    </div>
                                </a>
                            ))}
                        </div>
                    </div>
                    <div className="content-heading">
                        Respostas
                    </div>
                    <ul class="timeline timeline-alt mt-0 mb-0" style={{ marginTop: -35 }}>
                        {responses && responses.map(item => (
                            <li className="timeline-event mt-2 mb-3">
                                <div class="media">
                                    <div className="mr-3 ml-3 overlay-container overlay-left">
                                        <span className="overlay-item item item-tiny item-circle border border-2x border-white bg-success"></span>
                                    </div>
                                    <div className="block block-bordered block-fx-pop border-2x border-info" style={{width: "100%"}}>
                                        <div className="block-header pb-0">
                                            <div className="block-title pb-0">{item.user && item.user.name}</div>
                                            <div className="block-tools">
                                                <button className="btn btn-dual text-danger" onClick={()=>deleteComent(item)}>
                                                    <i className="si si-close"/>
                                                </button>
                                            </div>
                                        </div>
                                        <div className="block-content mb-3" style={{ whiteSpace: "pre-line" }}>
                                            {item.description} <br />
                                            <small>
                                                <i className="si si-calendar mr-1" /> {item && DateTranslate(item.createdDate)}
                                            </small>
                                        </div>
                                    </div>
                                </div>
                            </li>
                        ))}
                    </ul>

                    <div className="block block-fx-pop block-bordered border-2x border-warning">
                        <div className="block-content mb-3">
                            <div className="content-heading">
                                Enviar resposta
                            </div>
                            <div className="input-group input-group-lg">
                                <textarea className="form-control" value={response && response.description} name="description" onChange={evt => handleChange(evt)}/>
                                <div className="input-group-append">
                                    <button className="btn btn-warning" onClick={() => saveResponse()}>Enviar</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </Tab>
                <Tab eventKey="services" title="Serviços Selecionados" className="block-content">
                    <div className="content-heading">
                        <h4 className="text-muted">Serviços Selecionados</h4>
                    </div>
                    <ul>
                        {selectedServices.map(service => (
                            <li key={service.id}>{service.name}</li>
                        ))}
                    </ul>
                </Tab>
                <Tab
                    eventKey="timeline"
                    title={`Timeline`}>

                    <div className="text-muted py-1">Timeline</div>
                    <ul class="timeline timeline-alt mt-0 mb-0" style={{ marginTop: -35 }}>
                        {timeline && timeline.map(item => (
                            <li className="timeline-event mt-2 mb-3">
                                <div class="media">
                                    <div className="mr-3 ml-3 overlay-container overlay-left">
                                        <span className="overlay-item item item-tiny item-circle border border-2x border-white bg-success"></span>
                                    </div>
                                    <div className="media-body ml-2">
                                        {item.description} <br />
                                        <small>
                                            <i className="si si-calendar mr-1" /> {item && DateTranslate(item.createdDate)}
                                        </small>
                                    </div>
                                </div>
                            </li>
                        ))}
                    </ul>
                </Tab>
            </Tabs>
        </Modal>
    );
}
